/**
 * 考試規劃 — 型別。
 * Source of truth: docs/spec/EXAM_PLANNER_SPEC.md §2。
 *
 * 純學習側,不碰任何戰鬥數值(雙軌鐵則)。
 */
import type { Subject } from '../../shared/types';

export type { Subject };

/** 考試類型。段考(期中/期末)範圍累積;小考接續。 */
export type ExamType = 'midterm' | 'final' | 'quiz';

/** 規劃表一筆考試事件(使用者填日期)。 */
export interface ExamEvent {
  id: string;
  /** 顯示名;空字串時 UI 依 type(+ 小考科目)給預設。 */
  name: string;
  type: ExamType;
  /** 'YYYY-MM-DD' 本地日期(不存時分)。 */
  date: string;
  /**
   * 科目。小考通常單科(英文小考/數學小考…);段考(期中/期末)全科 → undefined。
   */
  subject?: Subject;
}

/** 學習端科目中文標籤(與 exam-bank loader 一致;教學介面用平實學科名)。 */
export const SUBJECT_LABEL: Record<Subject, string> = {
  chinese: '國語',
  math: '數學',
  english: '英文',
  nature: '自然',
  social: '社會',
};

/** 小考科目選單順序。 */
export const EXAM_SUBJECTS: Subject[] = ['chinese', 'math', 'english', 'nature', 'social'];

/** 一次考試對應的複習日期區間 `(from, to]`。 */
export interface ExamWindow {
  event: ExamEvent;
  /** 排他下界;null = 開學前全部(負無限)。 */
  from: string | null;
  /** 含上界(= event.date)。 */
  to: string;
}

/** type → 預設顯示名。 */
export const EXAM_TYPE_LABEL: Record<ExamType, string> = {
  midterm: '期中考',
  final: '期末考',
  quiz: '小考',
};

/** 段考(範圍累積);小考接續。 */
export function isSegmentExam(type: ExamType): boolean {
  return type === 'midterm' || type === 'final';
}
